do ->
  'use strict'

  # CURRENT USER ID
  angular.module('mainApp').factory 'currentUserId', ->
    angular.element("meta[name='current_user_id']").attr('id') || null
